<template>
  <div class="oldReleasePlan">
    <Sidebar :currently-belongs-to="currentlyBelongsTo" />
    <main class="oldReleasePlan_main">
      <LaunchPlan
        v-if="currentlyBelongsTo === 'LaunchPlan'"
        :promotion-objectives="promotionObjectives"
        :launch-plan="launchPlan"
        :promotion-objectives1="promotionObjectives1"
        :product="planobj.product.product_type"
        :pos_type="planobj.pos_type"
        :multislottype="planobj.target_groups[0].ad_groups[0].ad_group.multi_slot_type"
        :campaign="planobj.campaign"
        @setname="setname"

        @setpostype="planobj.pos_type = $event,creativeobj.pos_type = $event,planobj.target_groups[0].ad_groups[0].ad_group.pos_type = $event"

        @setnameproducttype="planobj.product.product_type = $event"
        @setDailyBudget="planobj.campaign.day_budget = $event"
        @campaignName="planobj.campaign.cname = $event"

        @setPromotion="launchPlan.promoted_object_type = $event"
        @setDeliver="launchPlan.campaign_type = $event"

        @setarr="setarr"
        @nextStep="nextStep"
      />
      <!-- v-else-if="currentlyBelongsTo === 'Advertisement'" -->
      <Advertisement
        v-if="currentlyBelongsTo && currentlyBelongsTo === 'Advertisement'"
        ref="adv"
        :current-ifon="advertisement.length ? advertisement[currentAdvertising] : {}"
        :campaign="planobj.campaign"
        :radioone="radioone"
        :radiotwo="radiotwo"
        :strategy_opt="planobj.target_groups[0].ad_groups[0].ad_group.strategy_opt"
        :bid_strategy="planobj.target_groups[0].ad_groups[0].ad_group.bid_strategy"
        :ad_target="planobj.target_groups[0].ad_groups[0].ad_target"

        :budget="planobj.target_groups[0].ad_groups[0].ad_group.budget"
        :bid="planobj.target_groups[0].ad_groups[0].ad_group.bid"
        :tracking_sourceid="planobj.target_groups[0].ad_groups[0].ad_group.tracking_sourceid"

        :objall="objall"
        :aname="planobj.target_groups[0].ad_groups[0].ad_group.aname"
        :zhuanhuaname="zhuanhuaname"

        @setinputvalueaname="planobj.target_groups[0].ad_groups[0].ad_group.aname = $event "

        @dataidsr="planobj.target_groups[0].ad_groups[0].ad_group.tracking_sourceid[0] = $event "
        @dataidsrempty="dataidsrempty"
        @dataname="zhuanhuaname= $event"
        @bendistrategyopt="bendistrategyopt"
        @budgetext="setbudgetext"
        @offertext="planobj.target_groups[0].ad_groups[0].ad_group.bid = $event "
        @toufangset="toufangset"

        @previousStep=" previousStep"
        @setLaunchTime="setLaunchTime"
        @setLaunchtimeall="setLaunchtimeall"
        @setTargetedPopulation="setTargetedPopulation"
        @setBudgetExpenditure="setBudgetExpenditure"
        @nextStep="nextStep1"
        @setinputvalue="setinputvalue"
        @setLaunchoose="radioone = $event"
        @setLaunchooseone="radiotwo = $event"
        @Targetedpopulation="Targetedpopulation"
      />
      <!-- v-else-if="currentlyBelongsTo === 'originality'" -->
      <Originality
        v-if="currentlyBelongsTo === 'originality'"
        :originality="originality"
        :creativeobj="creativeobj.materials[0]"
        :yuanshengname="nativepagejson.canvas_name"
        @previousStepthree="previousStepthree"
        @nextStep="nextStep2"
        @creativecallback="creativecallback"
        @creativeinput="creativeinput"
        @submitall="submitall"
        @jsonyuansheng="jsonyuanshengmethods"
        @setyuanshengname="nativepagejson.canvas_name = $event"
      />
    </main>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import LaunchPlan from './launchPlan.vue'
import Advertisement from './advertisement.vue'
import Originality from './originality.vue'
import { createAlldata, getbleRule, addAdvertise, editPublicads, mpadDetails, getDataSource, mpeditAd /* getPromotionplan,  createAdGroup , createAdvertisingPlan, createAdvertisingIdeas*/ } from '@/api/legacyPlan.js'
export default {
  components: {
    Sidebar,
    LaunchPlan,
    Advertisement,
    Originality
  },
  data() {
    return {
      planobj: {
        pos_type: 999,
        product: {
          product_type: 'PRODUCTTYPE_LEAD_AD',
          product_id: '',
          product_info: ''
        },
        campaign: {
          cid: 0,
          ctype: 'CAMPAIGNTYPE_AUCTION', // CAMPAIGNTYPE_AUCTION：竞价购买
          cname: '20220326-推广品牌活动-朋友圈信息流-竞价购买广告', // 计划名称
          can_mix_product: 1,
          client: '',
          day_budget: '', // 计划日预算
          end_time: 0, // 结束时间 长期投放就是0
          begin_time: '', // 开始时间
          exposure_frequency: 8
        },
        sub_product: {
          subordinate_product_id: '',
          product_type: 'PRODUCTTYPE_LEAD_AD',
          product_id: '',
          spname: ''
        },
        target_groups: [{
          target_group: {
            'mp_conf': `{ 'original_age': '[14,65]', 'poi_show': '0', 'version': '[]', 'city_level': '1', 'custom_poi': '[]', 'import_target_used': 'false', 'dmp_type': '', 'bid_action_type': '0', 'common_metric': { 'metrics': '[{"event_id":100029,"event_value":15309,"ext_json":"{"bid_range_tips":"137.78~199.01"}"}]', 'timestamp': '1648433245' }}`
          },
          ad_groups: [{
            ad_group: {
              aid: 0,
              backup_aid: 0,
              aname: '1322', //		"aname": "北京等-核心-男-14至60岁",//广告名称
              timeset: '', // 小时段
              product_id: '',
              product_type: 'PRODUCTTYPE_LEAD_AD',
              begin_time: '', // 上面的为基准 开始时间
              end_time: 0, // 上面的为基准 结束时间
              budget: null, // 每日预算
              day_budget: null, // 每日预算
              bid: null, // 出价
              multi_slot_type: 0, // 按形态投放 1展示Banner图片 2优雅横版大图 3沉浸式横版视频 其他0
              strategy_opt: { // 回传cpm  ocpm的值
                bid_objective: 2,
                bid_action_type: 2,
                bid_objective_mode: 1
              },
              bid_strategy: 1,
              change_bid: 0,
              contract_flag: 2,
              pos_type: 999, // 以其他的为基准投放位置
              exposure_frequency: 8,
              poi: '',
              expand_targeting_switch: 'EXPAND_TARGETING_SWITCH_CLOSE',
              expand_targeting_setting: '[]',
              cold_start_audience_id_list: '[]',
              time_mode: 0,
              auto_acquisition_switch: 0,
              auto_acquisition_budget: null,
              tracking_sourceid: [] // 转化归因数据源id
            },
            ad_target: {
              mid: 0,
              'ad_behavior': `[{"in_action_list":[],"not_in_action_list":[]}]`,
              education: '[]',
              device_price: '[]',
              area_type: 'travel_area', // 地域 area常驻地  travel_area差旅出行
              area: [], // area_type==常住地时的城市id
              travel_area: [], // area_type==差旅出行时的城市id
              gender: [], // 性别
              age: ['14~66'], // 年龄
              oversea: ['CN'], // 选择差旅出行的时候填CN,其他填空
              sns_optimal_user_group: '',
              device_brand_model: '[]',
              businessinterest: '[]',
              app_behavior: '{}',
              os: '[]',
              marriage_status: '[]',
              wechatflowclass: '[]',
              connection: '[]',
              telcom: '[]',
              payment: '[]',
              game_consumption_level: '[]',
              custom_poi: '[]',
              'weapp_version': `{"min_ios_version":0,"min_android_version":0,"min_ios_os_version":"","min_android_os_version":""}`,
              in_dmp_audience: '[]', // 自定义受众-定向人群
              not_in_dmp_audience: '[]', // 自定义受众-排除人群
              behavior_interest: '{}', // 兴趣行为
              star_fans: ''
            }
          }]
        }],
        expected_ret: 0,
        materials: [{
          tname: '创意-20220402_1', // 创意名称
          crt_size: 666
        }]
      },
      creativeobj: {
        cid: 5313355945,
        pos_type: 999,
        materials: [{
          rid: 5313355952,
          cid: 5313355945,
          desc: '', // 外层文案
          link_hidden: 0,
          link_name: '了解更多', // 文字链文案
          is_show_friend: 0,
          show_first_comment: 0,
          interaction: 0,
          crt_size: 666,
          tname: '创意-20220402_1', // 创意名字
          page_id: 2418236141,
          page_id_str: '2418236141',
          link_page_id: 2418236141,
          link_page_id_str: '0',
          page_type: 4,
          link_page_type: 4,
          dest_conf: '{}',
          ext_click_url: '',
          ext_exposure_url: '',
          dest_url: '',
          appmsg_info: '{}',
          title: '',
          scheme_url: '',
          is_hidden_comment: 0,
          crt_info: [],
          sns_dynamic_show_type: 0,
          sns_dynamic_show_text: ''
        }],
        product: {
          product_id: '',
          product_type: 'PRODUCTTYPE_LEAD_AD'
        }
      },
      nativepagejson: {
        share_title: '',
        share_desc: '',
        share_thumb: '',
        canvas_name: '', // 原生页名字名字 原生推广页20220331101142
        canvas_type: null,
        canvas_info: null,
        from_page_id: null
      },

      zhuanhuaname: '', // 转化归因名字

      promotionObjectives: {}, // 推广目标
      promotionObjectives1: [
        {
          name: 'PRODUCTTYPE_WECHAT_ARTICLE',
          value: '推广品牌活动'
        },
        {
          name: 'PRODUCTTYPE_LEAD_AD',
          value: '收集销售线索'
        },
        {
          name: 'PRODUCTTYPE_WECHAT',
          value: '推广公众号'
        }
      ],
      radioone: 'sone', // 投放时间第一个选择
      radiotwo: 'allday', // 投放时间段 (默认全天)
      launchPlan: {
        promoted_object_type: null,
        campaign_type: 'CAMPAIGN_TYPE_WECHAT_MOMENTS',
        campaign_name: '123',
        daily_budget: '',
        adcreative_template_id: '711'
      },
      promotion_objective: null, // 推广目标参数 推广目标 1推广品牌活动 2收集销售线索 3推广公众号
      deliveryposition: null, // 投放位置 投放位置 1朋友圈信息流 2公众平台流量
      site: null, // 1优雅横版大图 2沉浸式横版视频 3激励式广告
      objall: {},
      campaign_id: null,
      currentlyBelongsTo: 'LaunchPlan',
      advertisement: [],
      currentAdvertising: 0,
      originality: {
        adcreative_name: '开发测试0225创意',
        adcreative_template_id: 925,
        adcreative_elements: {
          image: 3094194161
        },
        promoted_object_type: 'PROMOTED_OBJECT_TYPE_LEAD_AD',
        site_set: ['SITE_SET_WECHAT'],
        page_type: 'PAGE_TYPE_CANVAS_WECHAT',
        page_spec: {
          page_id: 2319174795
        }
      }
    }
  },
  mounted() {
    console.log('query', this.$route.query)
    if (JSON.stringify(this.$route.query) === '{}') {
      sessionStorage.setItem('newtype', 'new')// 新增
      console.log('新增')
    }
    if (this.$route.query.index === 1) {
      console.log('公共页编辑')
      sessionStorage.setItem('newtype', 'edit1')// 编辑
      this.currentlyBelongsTo = ''
      getbleRule(this.$route.query.id).then(res => {
        console.log('res', res.data.json_one)
        if (res.code === 0) {
        // this.planobj = {}
          this.planobj = res.data.json_one
          this.creativeobj = res.data.json_three
          this.currentlyBelongsTo = 'LaunchPlan'
          console.log('this.planobj', this.planobj)
        }
      })
    }
    if (this.$route.query.index === 2) {
      sessionStorage.setItem('newtype', 'edit2')// 编辑
      console.log('选择公共页弹窗编辑 可选原生页 归因id')
      this.currentlyBelongsTo = ''
      getbleRule(this.$route.query.id).then(res => {
        console.log('res', res.data.json_one)
        if (res.code === 0) {
        // this.planobj = {}
          this.planobj = res.data.json_one
          this.creativeobj = res.data.json_three
          this.currentlyBelongsTo = 'LaunchPlan'
          console.log('this.planobj', this.planobj)
        }
      })
    }
    if (this.$route.query.index === 3) {
      sessionStorage.setItem('newtype', 'edit3')// 编辑
      console.log('选择完所有的编辑')
      this.currentlyBelongsTo = ''
      mpadDetails(this.$route.query.id).then(res => {
        console.log('res', JSON.parse(res.data.json_one))

        this.planobj = JSON.parse(res.data.json_one)
        this.creativeobj = JSON.parse(res.data.json_three)

        this.planobj.target_groups[0].ad_groups[0].ad_target.travel_area = JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_target.travel_area)

        this.planobj.target_groups[0].ad_groups[0].ad_target.area = JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_target.area)

        this.planobj.target_groups[0].ad_groups[0].ad_target.oversea = JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_target.oversea)

        this.planobj.target_groups[0].ad_groups[0].ad_target.gender = JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_target.gender)

        this.planobj.target_groups[0].ad_groups[0].ad_target.age = JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_target.age)

        this.planobj.target_groups[0].ad_groups[0].ad_group.tracking_sourceid = JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_group.tracking_sourceid)
        // 处理数据源名称
        if (JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_group.tracking_sourceid.length !== 0) {
          getDataSource().then(resw => {
            // console.log('进来', resw.data, JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_group.tracking_sourceid)[0])
            const index = resw.data.findIndex(item => {
              return item.user_action_set_id === JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_group.tracking_sourceid)[0]
            })
            if (index === -1) {
              // 不存在
            } else {
              // 存在
              this.zhuanhuaname = resw.data[index].name
            }
          })
        }

        this.planobj.target_groups[0].ad_groups[0].ad_group.strategy_opt = JSON.parse(JSON.parse(res.data.json_one).target_groups[0].ad_groups[0].ad_group.strategy_opt)

        // 处理第三个json数据 选择原生页
        //   nativepagejson: {
        //   share_title: '',
        //   share_desc: '',
        //   share_thumb: '',
        //   canvas_name: '', // 原生页名字名字 原生推广页20220331101142
        //   canvas_type: null,
        //   canvas_info: null,
        //   from_page_id: null
        // },
        this.nativepagejson.share_title = JSON.parse(res.data.json_two).share_title
        this.nativepagejson.share_desc = JSON.parse(res.data.json_two).share_desc
        this.nativepagejson.share_thumb = JSON.parse(res.data.json_two).share_thumb
        this.nativepagejson.canvas_name = JSON.parse(res.data.json_two).canvas_name
        this.nativepagejson.canvas_type = JSON.parse(res.data.json_two).canvas_type
        this.nativepagejson.canvas_info = JSON.parse(res.data.json_two).canvas_info
        this.nativepagejson.from_page_id = JSON.parse(res.data.json_two).from_page_id
        console.log('json_two', JSON.parse(res.data.json_two))
        this.currentlyBelongsTo = 'LaunchPlan'
        // if (res.code === 0) {
        // // this.planobj = {}
        //   this.planobj = res.data.json_one
        //   this.creativeobj = res.data.json_three
        //   this.currentlyBelongsTo = 'LaunchPlan'
        //   console.log('this.planobj', this.planobj)
        // }
      })
    }

    // // 编辑入口请求函数
    // if (JSON.stringify(this.$route.query) === '{}') {
    //   console.log('新增')
    //   sessionStorage.setItem('newtype', 'new')// 新增
    //   return false // 如果为空,返回false
    // } else {
    //   sessionStorage.setItem('newtype', 'edit')// 编辑
    //   this.currentlyBelongsTo = ''
    //   getbleRule(this.$route.query.id).then(res => {
    //     console.log('res', res.data.json_one)
    //     if (res.code === 0) {
    //     // this.planobj = {}
    //       this.planobj = res.data.json_one
    //       this.creativeobj = res.data.json_three
    //       this.currentlyBelongsTo = 'LaunchPlan'
    //       console.log('this.planobj', this.planobj)
    //     }
    //   })
    // }
  },
  created() {

    // const data = await getPromotionplan({
    //   account_id: this.$route.query.account_id
    // })
    // this.promotionObjectives = data.data.list
    // console.log('this.promotionObjectives', this.promotionObjectives)
    // this.launchPlan.promoted_object_type = Object.keys(data.data.list)[0]
    // 获取出价方式数据

    // 获取公共页数据 跳进来
  },
  methods: {
    // 获取出价配置
    getmanagement() {
      if (this.planobj.product.product_type === 'PRODUCTTYPE_WECHAT_ARTICLE') {
        // 推广品牌活动
        this.promotion_objective = 1
      }
      if (this.planobj.product.product_type === 'PRODUCTTYPE_LEAD_AD') {
        // 收集销售线索
        this.promotion_objective = 2
      }
      if (this.planobj.product.product_type === 'PRODUCTTYPE_WECHAT') {
        // 推广公众号
        this.promotion_objective = 3
      }
      if (this.planobj.pos_type === 999) {
      //  朋友圈信息流999
        this.deliveryposition = 1
      }
      if (this.planobj.pos_type !== 999) {
      //  朋友圈信息流999
        this.deliveryposition = 2
      }
      if (this.planobj.pos_type === 101 && this.planobj.target_groups[0].ad_groups[0].ad_group.multi_slot_type === 2) {
        // 优雅横版大图
        this.site = 1
      }
      if (this.planobj.pos_type === 101 && this.planobj.target_groups[0].ad_groups[0].ad_group.multi_slot_type === 3) {
        // 沉浸式横版视频
        this.site = 2
      }
      if (this.planobj.pos_type === 8 && this.planobj.target_groups[0].ad_groups[0].ad_group.multi_slot_type === 0) {
        // 激励式广告
        this.site = 3
      }
      if (this.planobj.pos_type === 999 && this.planobj.target_groups[0].ad_groups[0].ad_group.multi_slot_type === 0) {
        // 选择朋友圈 这个site值没有 后端传4 就好了
        console.log('9999')
        this.site = 4
      }
      // console.log(' this.promotion_objective', this.promotion_objective)
      // console.log(' this.deliveryposition', this.deliveryposition)
      // console.log(' this.site', this.site)
    },
    // 回传cpm  ocpm的值
    bendistrategyopt(event) {
      //  strategy_opt: { // 回传cpm  ocpm的值
      //       bid_objective: 2,
      //       bid_action_type: 1,
      //       bid_objective_mode: 1
      //     },
      console.log('已回传', event)
      this.planobj.target_groups[0].ad_groups[0].ad_group.strategy_opt.bid_objective = event.bid_objective
      this.planobj.target_groups[0].ad_groups[0].ad_group.strategy_opt.bid_action_type = event.bid_action_type
      this.planobj.target_groups[0].ad_groups[0].ad_group.strategy_opt.bid_objective_mode = event.bid_objective_mode
    },
    setCampaign_id(id) {
      this.campaign_id = id
      this.advertisement.push({

        begin_date: '', // 开始时间
        end_date: '', // 结束时间
        adgroup_name: '123', // 上面的名字
        billing_event: 'BILLINGEVENT_CLICK',
        optimization_goal: 'OPTIMIZATIONGOAL_CLICK',
        time_series:
          '1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111', // 投放时段
        site_set: ['SITE_SET_WECHAT'],
        bid_amount: 50, // 预算花费
        daily_budget: 50, // 出价
        targeting: {
          // 定向人群
          gender: [], // 性别
          education: [], // 学历
          user_os: [], // 操作系统
          device_price: [], // 手机价格
          age: [
            // 年龄
            {
              min: 18,
              max: 45
            }
          ],
          geo_location: {
            // 地域
            location_types: ['LIVE_IN'], // 常驻地或差旅出行
            regions: [] // 详情地址
          }
          // marital_status: [
          //   ' SINGLE',
          //   'SINGLE'
          // ],

        }
      })
    },
    setLaunchTime(obj) {
      console.log('obj1', obj)
      this.planobj.campaign.begin_time = obj.begin_date
      this.planobj.campaign.end_time = obj.end_date

      this.planobj.target_groups[0].ad_groups[0].ad_group.begin_time = obj.begin_date
      this.planobj.target_groups[0].ad_groups[0].ad_group.end_time = obj.end_date
      // this.advertisement[this.currentAdvertising] = { ...this.advertisement[this.currentAdvertising], ...obj }
    },
    // 选择推广目标回调
    setname(event) {
      this.planobj.product.product_type = event
      this.planobj.sub_product.product_type = event
      this.creativeobj.product.product_type = event
      this.planobj.target_groups[0].ad_groups[0].ad_group.product_type = event
    },
    setarr(obj) {
      console.log('回来了', obj.multi_slot_type)
      this.planobj.target_groups[0].ad_groups[0].ad_group.multi_slot_type = obj.multi_slot_type
    },
    // 定向人群赋值回来
    Targetedpopulation(obj) {
      console.log('我回来了', obj)
      if (obj.changregion === 'area') {
        // 等于常驻地 oversea等于空
        this.planobj.target_groups[0].ad_groups[0].ad_target.oversea = []
        this.planobj.target_groups[0].ad_groups[0].ad_target.travel_area = []
      }
      if (obj.changregion === 'travel_area') {
        // 等于差旅出行 oversea等于CN
        this.planobj.target_groups[0].ad_groups[0].ad_target.oversea = ['CN']
        this.planobj.target_groups[0].ad_groups[0].ad_target.area = []
      }
      this.planobj.target_groups[0].ad_groups[0].ad_target.area_type = obj.changregion
      this.planobj.target_groups[0].ad_groups[0].ad_target.age = [`${obj.startAgeitem}~${obj.endAgeitem}`]
      if (obj.allgender === '1') {
        this.planobj.target_groups[0].ad_groups[0].ad_target.gender = []
      } else {
        this.planobj.target_groups[0].ad_groups[0].ad_target.gender = [`${obj.allgender}`]
      }

      // 地理位置回调
      if (obj.changregion === 'travel_area') {
        this.planobj.target_groups[0].ad_groups[0].ad_target.travel_area = this.unique(obj.positionSelectValue)
      }
      if (obj.changregion === 'area') {
        this.planobj.target_groups[0].ad_groups[0].ad_target.area = this.unique(obj.positionSelectValue)
      }
    },
    unique(arr) {
      const resArr = []
      arr.forEach(item => {
        resArr.push(...item)
      })
      return [...new Set(resArr)]
    },
    setTargetedPopulation(obj) {
      // if (obj.gender && obj.gender.length === 0) {
      //   delete obj.gender
      // }
      // if (obj.education && obj.education.length === 0) {
      //   delete obj.education
      // }
      // if (obj.user_os && obj.user_os.length === 0) {
      //   delete obj.user_os
      // }
      // if (obj.device_price && obj.device_price.length === 0) {
      //   delete obj.device_price
      // }
      console.log('obj1', obj)
      this.advertisement[this.currentAdvertising] = { ...this.advertisement[this.currentAdvertising], targeting: obj }
    },
    setBudgetExpenditure(obj) {
      console.log('obj2', obj)
      this.advertisement[this.currentAdvertising] = { ...this.advertisement[this.currentAdvertising], ...obj }
    },
    setinputvalue(obj) {
      // console.log(obj)
      this.advertisement[this.currentAdvertising].adgroup_name = obj
    },
    setLaunchtimeall(obj) {
      console.log('回传回来的时间', obj)
      this.advertisement = [{ ...this.advertisement[this.currentAdvertising], ...obj }]
    },

    setbudgetext(val) {
      this.planobj.target_groups[0].ad_groups[0].ad_group.budget = val
      this.planobj.target_groups[0].ad_groups[0].ad_group.day_budget = val
    },
    async nextStep() {
      if (this.planobj.product.product_type === 'PRODUCTTYPE_WECHAT_ARTICLE' && this.planobj.target_groups[0].ad_groups[0].ad_group.multi_slot_type !== 0) {
        this.$message.error('请选择投放模式')
        return
      }
      if (this.planobj.campaign.day_budget === '') {
        this.$message.error('请输入预算')
        return
      }
      this.getmanagement()
      sessionStorage.setItem('promotion_objective', this.promotion_objective)
      sessionStorage.setItem('deliveryposition', this.deliveryposition)
      sessionStorage.setItem('site', this.site)

      // this.planobj.campaign.day_budget = this.planobj.campaign.day_budget * 10
      console.log('planobj', this.planobj)
      // console.log(JSON.parse())
      this.setCampaign_id(1 /* data.data.campaign_id */)
      this.currentlyBelongsTo = 'Advertisement'
    },
    async nextStep1() {
      console.log('planobj1', this.planobj)
      // if (this.advertisement[this.currentAdvertising].targeting.gender && this.advertisement[this.currentAdvertising].targeting.gender.length === 0) {
      //   delete this.advertisement[this.currentAdvertising].targeting.gender
      // }
      // if (this.advertisement[this.currentAdvertising].targeting.education && this.advertisement[this.currentAdvertising].targeting.education.length === 0) {
      //   delete this.advertisement[this.currentAdvertising].targeting.education
      // }
      // if (this.advertisement[this.currentAdvertising].targeting.user_os && this.advertisement[this.currentAdvertising].targeting.user_os.length === 0) {
      //   delete this.advertisement[this.currentAdvertising].targeting.user_os
      // }
      // if (this.advertisement) {
      //   console.log('this.advertisement', this.advertisement)
      // }

      /* await createAdGroup({
        account_id: this.$route.query.account_id,
        campaign_id: this.campaign_id,
        adgroups_data: this.advertisement.map(item => {
          return {
            ...item,
            ...this.launchPlan,
            daily_budget: 5000,
            bid_amount: 5000
          }
        })
      }) */
      // console.log(this.launchPlan)
      this.currentlyBelongsTo = 'originality'
    },
    async nextStep2(id) {
      console.log('666')
      /* const data = await createAdvertisingIdeas({
        campaign_id: this.campaign_id,
        account_id: 21958829,
        adcreative_name: '0219创意',
        adcreative_template_id: 925,
        adcreative_elements: {
          image: id
        },
        promoted_object_type: 'PROMOTED_OBJECT_TYPE_LEAD_AD',
        site_set: ['SITE_SET_WECHAT'],
        page_type: 'PAGE_TYPE_CANVAS_WECHAT',
        page_spec: {
          page_id: 2371169662
        }
      }) */
      // console.log(data)
    },
    // 第二级 点击上一步
    previousStep() {
      this.currentlyBelongsTo = 'LaunchPlan'
      // this.planobj.ad_groups[0].ad_group.strategy_opt.bid_objective = ''
      // this.planobj.ad_groups[0].ad_group.strategy_opt.bid_action_type = ''
      // this.planobj.ad_groups[0].ad_group.strategy_opt.bid_objective_mode = ''
    },
    // 投放模式回调
    toufangset(val) {
      console.log('投放模式回调', val)
      if (val === '') {
        console.log('空')
        this.planobj.target_groups[0].ad_groups[0].ad_group.bid_strategy = ''
      } else {
        console.log('zhengchang')
        this.planobj.target_groups[0].ad_groups[0].ad_group.bid_strategy = Number(val)
      }
    },
    previousStepthree() {
      this.currentlyBelongsTo = 'Advertisement'
      console.log('this.creativeobj', this.creativeobj)
    },
    // 创意回调
    creativecallback(obj) {
      this.creativeobj.materials[0].desc = obj.textarea// 文本域赋值
      this.creativeobj.materials[0].link_name = obj.link_name// 文字链文案
      console.log(obj)
    },
    // 创意名称回调
    creativeinput(val) {
      this.creativeobj.materials[0].tname = val
      this.planobj.materials[0].tname = val
    },
    // 原生页赋值回调
    jsonyuanshengmethods(val) {
      console.log('回传原生页', val)
      this.nativepagejson.share_title = val.share_title
      this.nativepagejson.share_desc = val.share_desc
      this.nativepagejson.share_thumb = val.share_thumb
      this.nativepagejson.canvas_type = val.canvas_type
      this.nativepagejson.canvas_info = val.canvas_info
      this.nativepagejson.from_page_id = val.page_id
      //       nativepagejson: {
      //   share_title: '',
      //   share_desc: '',
      //   share_thumb: '',
      //   canvas_name: '原生推广页20220331101142', // 原生页名字名字
      //   canvas_type: null,
      //   canvas_info: null,
      //   from_page_id: null
      // },
    },
    dataidsrempty() {
      this.planobj.target_groups[0].ad_groups[0].ad_group.tracking_sourceid = []
    },

    submitall() {
      if (this.planobj.target_groups[0].ad_groups[0].ad_group.bid_strategy === '') {
        console.log('bid_strategy为空')
        delete this.planobj.target_groups[0].ad_groups[0].ad_group.bid_strategy
      }
      // console.log(typeof (this.planobj.target_groups[0].ad_groups[0].ad_group.tracking_sourceid))
      // console.log(this.planobj.target_groups[0].ad_groups[0].ad_group.tracking_sourceid)
      console.log('第一个', this.planobj)
      // console.log(JSON.stringify(this.planobj))
      console.log('第二个', this.creativeobj)
      // console.log(JSON.stringify(this.creativeobj))
      console.log(' 第三个', this.nativepagejson)
      console.log('提交')

      if (JSON.stringify(this.$route.query) === '{}') {
        console.log('新增提交')
        createAlldata({
          campaign_name: this.planobj.campaign.cname, // 计划名称
          ad_name: this.planobj.target_groups[0].ad_groups[0].ad_group.aname, // 广告名
          tname: this.creativeobj.materials[0].tname,
          json_one: JSON.stringify(this.planobj),
          json_three: JSON.stringify(this.creativeobj)
        }).then(res => {
          this.$router.push('/customer/publicAdvertisingMP/index')
          console.log('res', res)
        })
      }
      if (this.$route.query.index === 1) {
        console.log('公共的修改提交')
        editPublicads(this.$route.query.id, {
          campaign_name: this.planobj.campaign.cname, // 计划名称
          ad_name: this.planobj.target_groups[0].ad_groups[0].ad_group.aname, // 广告名
          tname: this.creativeobj.materials[0].tname,
          json_one: JSON.stringify(this.planobj),
          json_three: JSON.stringify(this.creativeobj)
        }).then(response => {
          this.$router.push('/customer/publicAdvertisingMP/index')
          // thiz.item.dialogVisible = false
          // this.$message({
          //   message: this.$t('编辑管理员信息成功'),
          //   type: 'success',
          //   duration: 5 * 1000,
          //   onClose() {
          //     if (thiz.$refs.form !== undefined) {
          //       thiz.id = ''
          //       thiz.$refs.form.resetFields()
          //     }
          //   }
          // })
        })
      }
      if (this.$route.query.index === 2) {
        console.log('弹窗选择提交归因和原生页')
        // this.$router.push({
        //   path: '/accountAdvertising/index',
        //   query: {
        //     account_id: this.$route.query.account_id
        //   }
        // })

        addAdvertise({
          account_id: this.$route.query.account_id,
          common_ad_id: this.$route.query.id,
          campaign_name: this.planobj.campaign.cname, // 计划名称
          ad_name: this.planobj.target_groups[0].ad_groups[0].ad_group.aname, // 广告名
          tname: this.creativeobj.materials[0].tname,
          json_one: JSON.stringify(this.planobj),
          json_three: JSON.stringify(this.creativeobj),
          json_two: this.nativepagejson
        }).then(res => {
          this.$router.push({
            path: '/accountAdvertising/index',
            query: {
              account_id: this.$route.query.account_id
            }
          })
        })
      }
      if (this.$route.query.index === 3) {
        console.log('都选择完编辑')
        mpeditAd(this.$route.query.id, {
          campaign_name: this.planobj.campaign.cname, // 计划名称
          ad_name: this.planobj.target_groups[0].ad_groups[0].ad_group.aname, // 广告名
          tname: this.creativeobj.materials[0].tname,
          json_one: JSON.stringify(this.planobj),
          json_three: JSON.stringify(this.creativeobj),
          json_two: this.nativepagejson
        }).then(res => {
          this.$router.push({
            path: '/accountAdvertising/index',
            query: {
              account_id: this.$route.query.account_id
            }
          })
        })
      }
    }
    // if (JSON.stringify(this.$route.query) === '{}') {
    //   console.log('新增')

    //   // 新增
    //   createAlldata({
    //     campaign_name: this.planobj.campaign.cname, // 计划名称
    //     ad_name: this.planobj.target_groups[0].ad_groups[0].ad_group.aname, // 广告名
    //     tname: this.creativeobj.materials[0].tname,
    //     json_one: JSON.stringify(this.planobj),
    //     json_three: JSON.stringify(this.creativeobj)
    //   }).then(res => {
    //     this.$router.push('/customer/publicAdvertisingMP/index')
    //     console.log('res', res)
    //   })
    //   return false // 如果为空,返回false
    // } else {
    //   // 编辑
    //   // this.$router.push({
    //   //   path: '/accountAdvertising/index',
    //   //   query: {
    //   //     account_id: this.$route.query.account_id
    //   //   }
    //   // })

    //   addAdvertise({
    //     account_id: this.$route.query.account_id,
    //     common_ad_id: this.$route.query.id,
    //     campaign_name: this.planobj.campaign.cname, // 计划名称
    //     ad_name: this.planobj.target_groups[0].ad_groups[0].ad_group.aname, // 广告名
    //     tname: this.creativeobj.materials[0].tname,
    //     json_one: JSON.stringify(this.planobj),
    //     json_three: JSON.stringify(this.creativeobj),
    //     json_two: this.nativepagejson
    //   }).then(res => {

    //   })
    //   console.log('编辑')
    // }
  }
}

</script>

<style scoped lang="less">
.oldReleasePlan {
  position: relative;
  width: 100%;
  height: calc(100%);
  display: flex;
  .oldReleasePlan_main {
    background-color: #f7f7f7;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    padding: 20px 0px;
    overflow: scroll;
  }
}
</style>
